import {
    GET_GROUP_OPTIONS_PERMISSIONS_SUCCESS,
    GET_GROUP_OPTIONS_PERMISSIONS_FAILURE,
} from '../constants/get_group_data.constants';

export const getGroupOptionsPermissionsSuccess = payload => ({
    type: GET_GROUP_OPTIONS_PERMISSIONS_SUCCESS, payload,
});

export const getGroupOptionsPermissionsFailure = error => ({
    type: GET_GROUP_OPTIONS_PERMISSIONS_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/get_group_options_permissions.actions.js